import { styled, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getTeamSessionStats, getUserSessionStats } from '../api/stats';
import Layout from '../components/Layout';
import ProgressSessionProgress from '../components/progressSessionProgress';
import ProgressTrajectory from '../components/progressTrajectory';
import { colors } from '../styles/globalStyles';
import { userForAdminPanelAtom } from '../recoil/atoms/userAtom';
import { useRecoilValue } from 'recoil';
import data from '../data/data.json';
import { selectedLanguageAtom } from '../recoil/atoms/languageAtom';

const Header = styled('header')({
    padding: 10,

    display: 'flex',
    alignItems: 'center',
    gap: 8,
});

const TypographyHeader = styled(Typography)({
    fontWeight: 700,
    fontSize: 24,
    lineHeight: '100%',

    '& span': {
        color: colors.main,
    },
});

const ProgressPage = () => {
    const selectedLanguage = useRecoilValue(selectedLanguageAtom);
    const { progressPage } = data[selectedLanguage];
    const [isLoading, setIsLoading] = useState(true);
    const [userStats, setUserStats] = useState([
        { session: 1 },
        { session: 2 },
        { session: 3 },
        { session: 4 },
        { session: 5 },
        { session: 6 },
        { session: 7 },
    ]);
    const [teamStats, setTeamStats] = useState([
        { session: 1 },
        { session: 2 },
        { session: 3 },
        { session: 4 },
        { session: 5 },
        { session: 6 },
        { session: 7 },
    ]);
    const [maxScore, setMaxScore] = useState(0);
    const userForAdminPanel = useRecoilValue(userForAdminPanelAtom);

    const fillStatsData = (stats, setStats, responseArr) => {
        if (responseArr.length < 7) {
            const newStats = Object.assign([], stats);
            responseArr.forEach((item) => {
                // setStats((prev) => {
                //     prev[item.session - 1] = item;
                //     return prev;
                // });
                newStats[item.session - 1] = item;
                setStats(newStats);
            });
        } else {
            setStats(responseArr);
        }
    };

    useEffect(() => {
        Promise.allSettled([
            getUserSessionStats('week', userForAdminPanel.id, userForAdminPanel.teams?.[0].id),
            getTeamSessionStats('week', userForAdminPanel.id, userForAdminPanel.teams?.[0].id),
        ]).then(([userSessionStats, teamSessionStats]) => {
            if (userSessionStats.status === 'fulfilled') {
                fillStatsData(userStats, setUserStats, userSessionStats.value.data.sessions);
                setMaxScore(userSessionStats.value.data['max_score']);
            }

            if (teamSessionStats.status === 'fulfilled') {
                fillStatsData(teamStats, setTeamStats, teamSessionStats.value.data.sessions);
                setMaxScore(teamSessionStats.value.data['max_score']);
            }

            setIsLoading(false);
        });
    }, []);

    return (
        <Layout link={'/'}>
            <Header>
                <TypographyHeader dangerouslySetInnerHTML={{ __html: progressPage.title }} />
            </Header>
            <ProgressTrajectory isLoading={isLoading} />
            <ProgressSessionProgress type={'user'} data={userStats} maxScore={maxScore} isLoading={isLoading} />
            <ProgressSessionProgress type={'team'} data={teamStats} maxScore={maxScore} isLoading={isLoading} />
        </Layout>
    );
};

export default ProgressPage;
